module.exports = __webpack_public_path__ + "img/banner.77ec3c87.jpg";